<template>
  <div :class="className" :style="{ height: height, width: width }" />
</template>

<script>
import * as echarts from "echarts";
import chartResize from "./mixins/chart-resize";

export default {
  name: "DoubleLineEchart",
  mixins: [chartResize],
  props: {
    className: {
      type: String,
      default: "chart",
    },
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    autoResize: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    chartData: {
      type: Object,
      required: true,
    },
    xAxisName: {
      type: String,
      default: "",
    },
    yAxisName: {
      type: String,
      default: "",
    },
    legendData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  watch: {
    chartData: {
      deep: true,
      handler(val) {
        this.setOptions(val);
      },
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initChart();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    initChart() {
      this.chart = echarts.init(this.$el);
      this.setOptions(this.chartData);
    },
    setOptions(data) {
      const option = {
        backgroundColor: "transparent",
        grid: {
          top: "10%",
          bottom: "15%",
          left: "5%",
          right: "4%",
        },
        tooltip: {
          trigger: "axis",
          label: {
            show: true,
          },
        },
        legend: {
          icon: "circle",
          align: "left",
          itemWidth: 8,
          itemHeight: 8,
          itemGap: 20,
          borderRadius: 4,
          textStyle: {
            fontSize: 14,
            color: "#c0c3cd",
          },
          x: "center",
          y: "bottom",
          data: this.legendData,
        },
        xAxis: {
          boundaryGap: true, //默认，坐标轴留白策略
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#c0c3cd",
            fontSize: 12,
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
            alignWithLabel: true,
          },
          data: this.chartData.xData,
        },
        yAxis: {
          axisLine: {
            show: false,
          },
          axisLabel: {
            color: "#c0c3cd",
            fontSize: 12,
          },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "rgba(33,148,246,0.2)",
            },
          },
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            name: this.legendData[0] || "",
            type: "line",
            symbol: "circle",
            symbolSize: 7,
            lineStyle: {
              color: "#52C1F5",
              shadowBlur: 12,
              shadowColor: "rgba(82, 193, 245, 0.9)",
              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(82, 193, 245, 0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(82, 193, 245, 0.3)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(82, 193, 245, 0.1)",
              },
            },
            itemStyle: {
              color: "#52C1F5",
              borderWidth: 1,
              borderColor: "#FFF",
            },

            data: data.data1,
          },
          {
            name: this.legendData[1] || "",
            type: "line",
            symbol: "circle",
            symbolSize: 7,
            lineStyle: {
              color: "#FF7A8C",
              shadowBlur: 12,
              shadowColor: "rgba(255,122,140, 0.9)",
              shadowOffsetX: 1,
              shadowOffsetY: 1,
            },
            areaStyle: {
              normal: {
                color: new echarts.graphic.LinearGradient(
                  0,
                  0,
                  0,
                  1,
                  [
                    {
                      offset: 0,
                      color: "rgba(255,122,140, 0.5)",
                    },
                    {
                      offset: 1,
                      color: "rgba(255,122,140, 0.3)",
                    },
                  ],
                  false
                ),
                shadowColor: "rgba(255,122,140, 0.1)",
              },
            },
            itemStyle: {
              color: "#FF7A8C",
              borderWidth: 1,
              borderColor: "#FFF",
            },

            data: data.data2,
          },
        ],
      };

      this.chart.setOption(option);
    },
  },
};
</script>
